import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { liveRegion, isDuringQuizTake } from '@instructure/quiz-common';
var DEFAULT_LANGUAGE = 'en';
export var pageChecks = {
  isQuizTaking: function isQuizTaking() {
    return isDuringQuizTake();
  }
};
export var areAllRcsKeysPresent = function areAllRcsKeysPresent(props) {
  return !!(props !== null && props !== void 0 && props.canvasUserId && props !== null && props !== void 0 && props.contextId && props !== null && props !== void 0 && props.contextType && props !== null && props !== void 0 && props.rcsHost && props !== null && props !== void 0 && props.rcsJwt && props !== null && props !== void 0 && props.rcsJwtRefreshFn && props !== null && props !== void 0 && props.canvasConfig);
};
export var shouldUseIconMaker = function shouldUseIconMaker(canvasConfig) {
  var _canvasConfig$FEATURE;
  return !!(canvasConfig !== null && canvasConfig !== void 0 && canvasConfig.RICH_CONTENT_CAN_UPLOAD_FILES && canvasConfig !== null && canvasConfig !== void 0 && canvasConfig.RICH_CONTENT_CAN_EDIT_FILES && canvasConfig !== null && canvasConfig !== void 0 && (_canvasConfig$FEATURE = canvasConfig.FEATURES) !== null && _canvasConfig$FEATURE !== void 0 && _canvasConfig$FEATURE.buttons_and_icons_root_account);
};
export var getBodyClass = function getBodyClass(canvasConfig) {
  var _canvasConfig$FEATURE2;
  return canvasConfig !== null && canvasConfig !== void 0 && (_canvasConfig$FEATURE2 = canvasConfig.FEATURES) !== null && _canvasConfig$FEATURE2 !== void 0 && _canvasConfig$FEATURE2.canvas_k6_theme || canvasConfig !== null && canvasConfig !== void 0 && canvasConfig.K5_SUBJECT_COURSE || canvasConfig !== null && canvasConfig !== void 0 && canvasConfig.K5_HOMEROOM_COURSE ? 'elementary-theme' : 'default-theme';
};
var composeDefaultContentStyles = function composeDefaultContentStyles(defaultRceSettings) {
  var _ref = defaultRceSettings || {},
    enabled = _ref.enabled,
    font = _ref.font,
    fontSize = _ref.fontSize;
  if (!enabled) return null;
  var hasFont = font && font !== 'Default';
  var hasFontSize = fontSize && fontSize !== 'Default';
  if (hasFont || hasFontSize) {
    return "body {\n      ".concat(hasFont ? "font-family: ".concat(font, " !important;") : '', "\n      ").concat(hasFontSize ? "font-size: ".concat(fontSize, ";") : '', "\n    }");
  }
};
export var getEditorOptions = function getEditorOptions(canvasConfig, textareaId, spellCheck, wordCount, autoFocus, actsAsInput, defaultRceSettings) {
  var _canvasConfig$kaltura;
  var body_class = getBodyClass(canvasConfig);
  var show_media_upload = (canvasConfig === null || canvasConfig === void 0 || (_canvasConfig$kaltura = canvasConfig.kalturaSettings) === null || _canvasConfig$kaltura === void 0 ? void 0 : _canvasConfig$kaltura.hide_rte_button) === false;
  var selector = "#".concat(textareaId);
  var content_css = canvasConfig === null || canvasConfig === void 0 ? void 0 : canvasConfig.url_to_what_gets_loaded_inside_the_tinymce_editor_css;
  var htmlEl = document.documentElement;
  var directionality = htmlEl.getAttribute('dir') || getComputedStyle(htmlEl, null).direction;
  var auto_focus = autoFocus || actsAsInput;

  // only disable spell check if its explicitly turned off
  // if it is undefined, we fall back to turn it on
  var disableSpellcheck = spellCheck === false;
  var browser_spellcheck = !disableSpellcheck;

  // only disable word count if its explicitly turned off
  // if it is undefined, we fall back to show it
  var disableWordCount = wordCount === false;
  var plugins = disableWordCount ? ['-instructure_wordcount'] : [];
  return {
    body_class: body_class,
    selector: selector,
    directionality: directionality,
    content_css: content_css,
    content_style: composeDefaultContentStyles(defaultRceSettings),
    show_media_upload: show_media_upload,
    auto_focus: auto_focus,
    browser_spellcheck: browser_spellcheck,
    plugins: plugins
  };
};
var calculateContext = function calculateContext(containingContext) {
  var generateContext = function generateContext(contextType, contextId) {
    return {
      contextType: contextType,
      contextId: contextId
    };
  };
  return containingContext.contextType === 'account' || pageChecks.isQuizTaking() ? generateContext('user', containingContext.userId) : generateContext(containingContext.contextType, containingContext.contextId);
};
export var mapLtiAppConfig = function mapLtiAppConfig(props) {
  if (!props.ltiApps) return null;
  return {
    externalToolsConfig: {
      containingCanvasLtiToolId: props.ltiApps.canvasToolId,
      ltiIframeAllowances: props.ltiApps.ltiIframeAllowances
    },
    ltiTools: props.ltiApps.editorButtons
  };
};
export var mapRcsPropsToCanvasRceRcsProps = function mapRcsPropsToCanvasRceRcsProps(rcsProps, stem) {
  if (!areAllRcsKeysPresent(rcsProps)) {
    return undefined;
  }
  var contextType = rcsProps.contextType,
    contextId = rcsProps.contextId,
    userId = rcsProps.canvasUserId,
    resourceType = rcsProps.resourceType,
    resourceId = rcsProps.resourceId,
    host = rcsProps.rcsHost,
    jwt = rcsProps.rcsJwt,
    refreshToken = rcsProps.rcsJwtRefreshFn,
    canvasConfig = rcsProps.canvasConfig;
  var canUploadFiles = canvasConfig.RICH_CONTENT_CAN_UPLOAD_FILES,
    filesTabDisabled = canvasConfig.RICH_CONTENT_FILES_TAB_DISABLED,
    themeUrl = canvasConfig.active_brand_config_json_url,
    canvasUrl = canvasConfig.DEEP_LINKING_POST_MESSAGE_ORIGIN,
    FEATURES = canvasConfig.FEATURES;
  var _ref2 = FEATURES || {},
    _ref2$buttons_and_ico = _ref2.buttons_and_icons_cropper,
    icon_maker_cropper = _ref2$buttons_and_ico === void 0 ? false : _ref2$buttons_and_ico,
    _ref2$rce_ux_improvem = _ref2.rce_ux_improvements,
    rce_ux_improvements = _ref2$rce_ux_improvem === void 0 ? false : _ref2$rce_ux_improvem;
  var features = {
    icon_maker_cropper: icon_maker_cropper,
    rce_ux_improvements: rce_ux_improvements
  };
  var containingContext = {
    contextType: contextType,
    contextId: contextId,
    userId: userId,
    resourceId: resourceId,
    resourceType: resourceType
  };
  var context = calculateContext(containingContext);
  var wrappedRefreshToken = function wrappedRefreshToken(setTokenFn) {
    refreshToken(setTokenFn, stem);
  };
  return _objectSpread(_objectSpread({
    containingContext: containingContext
  }, context), {}, {
    host: host,
    jwt: jwt,
    refreshToken: wrappedRefreshToken,
    canUploadFiles: canUploadFiles,
    filesTabDisabled: filesTabDisabled,
    themeUrl: themeUrl,
    canvasUrl: canvasUrl,
    features: features
  });
};
export var mapQuizRcePropsToCanvasRceProps = function mapQuizRcePropsToCanvasRceProps() {
  var _props$editorOptions, _props$editorOptions2;
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var callbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var textareaId = props.textareaId,
    defaultContent = props.defaultContent,
    stem = props.stem,
    readOnly = props.readOnly,
    onFocus = props.onFocus,
    autoFocus = props.autoFocus,
    inputRcsPros = props.rcsProps,
    rendererEnhancement = props.rendererEnhancement,
    height = props.height,
    actsAsInput = props.actsAsInput,
    defaultRceSettings = props.defaultRceSettings;
  var spellCheck = (_props$editorOptions = props.editorOptions) === null || _props$editorOptions === void 0 ? void 0 : _props$editorOptions.spellCheck;
  var showWordCount = (_props$editorOptions2 = props.editorOptions) === null || _props$editorOptions2 === void 0 ? void 0 : _props$editorOptions2.wordCount;
  var onBlur = callbacks.onBlur,
    onContentChange = callbacks.onContentChange,
    onInit = callbacks.onInit;
  var canvasConfig = (inputRcsPros === null || inputRcsPros === void 0 ? void 0 : inputRcsPros.canvasConfig) || {};
  var highContrastCSS = canvasConfig.url_for_high_contrast_tinymce_editor_css,
    instRecordDisabled = canvasConfig.RICH_CONTENT_INST_RECORD_TAB_DISABLED,
    LOCALE = canvasConfig.LOCALE,
    FEATURES = canvasConfig.FEATURES;
  var features = FEATURES || {};
  var language = LOCALE || DEFAULT_LANGUAGE;
  var use_rce_icon_maker = shouldUseIconMaker(canvasConfig);
  var rcsProps = areAllRcsKeysPresent(inputRcsPros) ? mapRcsPropsToCanvasRceRcsProps(inputRcsPros, stem) : null;
  var editorOptions = _objectSpread({}, getEditorOptions(canvasConfig, textareaId, spellCheck, showWordCount, autoFocus, actsAsInput, defaultRceSettings));
  var canvasOrigin = rendererEnhancement === null || rendererEnhancement === void 0 ? void 0 : rendererEnhancement.canvasOrigin;
  var rceProps = {
    textareaId: textareaId,
    canvasOrigin: canvasOrigin,
    defaultContent: defaultContent,
    onContentChange: onContentChange,
    onInit: onInit,
    liveRegion: liveRegion,
    editorOptions: editorOptions,
    features: features,
    height: height,
    rcsProps: rcsProps,
    highContrastCSS: highContrastCSS,
    instRecordDisabled: instRecordDisabled,
    use_rce_icon_maker: use_rce_icon_maker,
    readOnly: readOnly,
    onBlur: onBlur,
    onFocus: onFocus,
    language: language
  };
  var ltiApps = mapLtiAppConfig(props);
  return ltiApps ? _objectSpread(_objectSpread({}, rceProps), ltiApps) : rceProps;
};